import { render } from "./SubAgent.vue?vue&type=template&id=65f9fea2&scoped=true"
import script from "./SubAgent.vue?vue&type=script&lang=js"
export * from "./SubAgent.vue?vue&type=script&lang=js"

import "./SubAgent.vue?vue&type=style&index=0&id=65f9fea2&lang=scss&scoped=true"
import "./SubAgent.vue?vue&type=style&index=1&id=65f9fea2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f9fea2"]])

export default __exports__